
export const API_DOMAIN = typeof OTG_API_CONFIG == 'object' && OTG_API_CONFIG.domain ? OTG_API_CONFIG.domain : window.API_DOMAIN
export const OTG_API_JWT = typeof OTG_API_CONFIG == 'object' && OTG_API_CONFIG.jwt ? OTG_API_CONFIG.jwt : window.OTG_API_JWT
